import React, { useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import photo4 from "../photos/photo4.jpeg";
import tulayyildirim1 from "../photos/tulayyildirim1.jpeg";
import tulayyildirim3 from "../photos/tulayyildirim3.jpeg";

const photos = [tulayyildirim1, photo4, tulayyildirim3];

const About = () => {
  const [activePhoto, setActivePhoto] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActivePhoto((current) => (current + 1) % photos.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const changePhoto = (direction) => {
    setActivePhoto((current) => (current + direction + photos.length) % photos.length);
  };

  return (
    <main className="about-page page-width">
      <section className="about-layout">
        <div className="about-portrait reveal">
          <div className="about-images">
            {photos.map((photo, index) => (
              <img
                src={photo}
                key={photo}
                className={index === activePhoto ? "is-active" : ""}
                alt="DR. TÜLAY YILDIRIM"
                aria-hidden={index !== activePhoto}
              />
            ))}
          </div>
          <div className="about-controls">
            <button type="button" onClick={() => changePhoto(-1)} aria-label="Previous">
              <FiChevronLeft />
            </button>
            <div>
              {photos.map((photo, index) => (
                <button
                  type="button"
                  key={photo}
                  className={index === activePhoto ? "is-active" : ""}
                  onClick={() => setActivePhoto(index)}
                  aria-label={`Slide ${index + 1}`}
                />
              ))}
            </div>
            <button type="button" onClick={() => changePhoto(1)} aria-label="Next">
              <FiChevronRight />
            </button>
          </div>
        </div>

        <article className="about-copy reveal">
          <div className="section-ornament" aria-hidden="true"><span /></div>
          <header>DR.TÜLAY YILDIRIM</header>
          <h1>Medikal Estetik</h1>
          <p>
            1995 yılında Anadolu(Osmangazi) üniversitesi Tıp fakültesinden mezun
            oldum.2004 yılında Medikal Estetik Hekimliği eğitim ve sertifikasını
            aldıktan sonra Flavius Güzellik Merkezi doktoru olarak 5 yıl
            çalıştım.Daha sonra İzmir Essi Güzellik Merkezi şubelerinin doktoru
            olarak çalıştım.
          </p>
          <p>
            Şu anda 26 yıllık hekimim ve kendi muayenehanemde
            <strong> hizmet vermekteyim.</strong>
          </p>
          <p className="about-signature">Sevgi ile kalın ..</p>
          <blockquote>
            <p>
              " Küçük dokunuşlarla daha dinlenmiş,daha sağlıklı bir görünüm
              için,kendimize olan güvenimizin artması,daha güzel yaş almak için
              güvenilir bir adres arıyorsanız Kliniğimize bekleriz.."
            </p>
            <p>"Hayatınıza ve imajınıza dokunmaya devam ediyoruz.."</p>
          </blockquote>
        </article>
      </section>
    </main>
  );
};

export default About;
